import React from "react";
import { type CheckboxOptionProps } from "./checkboxOption.types";

const CheckboxOption = React.forwardRef<HTMLInputElement, CheckboxOptionProps>(
    ({ id, label, checked, onChange, className = "", ...props }, ref) => {
        return (
            <div
                className={`bg-white p-6 rounded-[8px] flex items-start hover:border-gray-400 transition-colors duration-200 ${className}`}
            >
                <input
                    id={id}
                    type="checkbox"
                    ref={ref}
                    checked={checked}
                    onChange={onChange}
                    className="cursor-pointer w-5 h-5 ms-2 shrink-0 accent-[var(--color-gray-900)] bg-[var(--color-bg-light)] border border-gray-400 rounded-[3px] appearance-none checked:bg-[var(--color-gray-900)] focus:outline-none focus:ring-4 focus:ring-[rgba(24,26,32,0.25)]"
                    {...props}
                />
                <label htmlFor={id} className="ms-3 text-xl select-none cursor-pointer">
                    {label}
                </label>
            </div>
        );
    }
);

CheckboxOption.displayName = "CheckboxOption";
export { CheckboxOption };
